export enum CommissionEnum {
    PENDING_INVOICE = "pending-invoices",
    PAID_COMMISSIONS = "paid-commissions",
    WITHHELD_COMMISSIONS = "witheld",
    FUTURE_COMMISSION = "future-comission",
    CONVERSION_BONUS = "conversion-bonus",
}


export function mapToReportFilename(comission: CommissionEnum) {
  switch (comission) {
    case CommissionEnum.PENDING_INVOICE:
      return 'comissões-pendentes.pdf';
    case CommissionEnum.PAID_COMMISSIONS:
      return 'comissões-pagas.pdf';
    case CommissionEnum.WITHHELD_COMMISSIONS:
      return 'comissões-retidas.pdf';
    case CommissionEnum.FUTURE_COMMISSION:
      return 'comissões-futuras.pdf';
    case CommissionEnum.CONVERSION_BONUS:
      return 'bônus-conversão.pdf';
    default:
      throw new Error("Tipo de filtro de comissão inválido.");
  }
}
